import { MasterDataCrud } from '@diamond/shared/schema/master-data';
import {
  ProductCrud,
  ProductExcludeBranchCrud,
} from '@diamond/shared/schema/product';
import { ShiptoCrud } from '@diamond/shared/schema/shipto';
import { apiInstance } from '@diamond/shared/utils';

export type ExclusionRule = ProductExcludeBranchCrud['create']['body'];
export type ExclusionQuery = ProductExcludeBranchCrud['list']['query'];
export type ExclusionRow =
  ProductExcludeBranchCrud['list']['response']['data'][number];
const RESOURCE = '/backoffice/product-exclude-branch';

export function exclusionApi(token: string) {
  const client = apiInstance(token);
  return {
    list: async (params: ExclusionQuery) =>
      (
        await client.get<ProductExcludeBranchCrud['list']['response']>(
          RESOURCE,
          { params }
        )
      ).data,
    create: async (body: ExclusionRule) =>
      (
        await client.post<ProductExcludeBranchCrud['create']['response']>(
          RESOURCE,
          body
        )
      ).data,
    bulkCreate: async (items: ExclusionRule[]) =>
      (
        await client.post<ProductExcludeBranchCrud['bulkCreate']['response']>(
          `${RESOURCE}/bulk`,
          { items }
        )
      ).data,
    remove: async (id: string) =>
      (
        await client.delete<ProductExcludeBranchCrud['delete']['response']>(
          `${RESOURCE}/${id}`
        )
      ).data,
    bulkRemove: async (ids: string[]) =>
      (
        await client.post<ProductExcludeBranchCrud['bulkDelete']['response']>(
          `${RESOURCE}/bulk-delete`,
          { ids }
        )
      ).data,
    products: async (search: string) =>
      (
        await client.get<ProductCrud['getManyProducts']['response']>(
          '/backoffice/product/list',
          {
            params: { page: 1, size: 20, search_query: search || undefined },
          }
        )
      ).data,
    channels: async () =>
      (
        await client.get<ShiptoCrud['getDistributionChannel']['response']>(
          '/backoffice/shipto/distribution-channel'
        )
      ).data,
    cg1: async () =>
      (
        await client.get<ShiptoCrud['getCustomerType']['response']>(
          '/backoffice/shipto/customer-type'
        )
      ).data,
    plants: async (channel: string) =>
      (
        await client.get<MasterDataCrud['getPlants']['response']>(
          '/backoffice/master-data/plants',
          {
            params: { distribution_channel: channel || undefined },
          }
        )
      ).data,
  };
}
